import { useEffect, useState } from "react";
import { useAuthDispatch, useAuthStore } from "../contexts/AuthContext";
import { useUserDispatch } from "../contexts/UserContext";
import { useAccountDispatch } from "../contexts/AccountContext";

//make call to api to get users and dispatch them to the user store
export const useGetUsers = () => {
  const userDispatch = useUserDispatch();
  const { selectedAccount } = useAuthStore();
  useEffect(() => {
    userDispatch({ type: "setIsLoadingUsers", payload: true });

    async function getUsers() {
      const response = await fetch(
        `/api/users${
          selectedAccount?.id ? `?account=${selectedAccount.id}` : ""
        }`
      );
      const val = await response.json();
      return val;
    }
    // TODO: BUG HERE when i accessed users from victor's account - Fixed
    async function getAndDispatchUsers() {
      const users = await getUsers();
      userDispatch({ type: "get", payload: users });
      userDispatch({ type: "setIsLoadingUsers", payload: false });
    }
    getAndDispatchUsers();
  }, [userDispatch, selectedAccount]);
};

//get and return a single user by id
export const getUserById = async (id) => {
  const response = await fetch("/api/users/" + id);
  const user = await response.json();
  return user;
};

// payload: email, accountId, roleId
export function useCreateUsers(payload) {
  const userDispatch = useUserDispatch();
  const [userRolesObj, setUserRolesObj] = useState(payload);
  const accountDispatch = useAccountDispatch();
  const { selectedAccount } = useAuthStore();

  async function createUsers() {
    const response = await fetch(`/api/users`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userRolesObj),
    });
    if (response.ok) {
      let data = await response.json();
      userDispatch({ type: "addUsers", payload: data });

      // to update the userCount in accounts table, Account context must be updated
      accountDispatch({ type: "setIsLoadingAccounts", payload: true });

      //  for super admins with "Innovare" selected as the account (no id), return all accounts
      let url = selectedAccount.id
        ? `/api/accounts?account=${selectedAccount.id}`
        : "/api/accounts";

      fetch(url)
        .then((r) => r.json())
        .then((data) => {
          accountDispatch({ type: "setAccounts", payload: data });
          accountDispatch({ type: "setIsLoadingAccounts", payload: false });
        });
      return data;
    } else {
      // add here to handle if there emails in our database already
      const errorData = await response.json();
      if (errorData?.reachedLimit) {
        return errorData;
      }
      const errorMessage = errorData.message;
      return errorMessage;
    }
  }
  return { userRolesObj, setUserRolesObj, createUsers };
}

// update user by clicking edit button
// payload: fristName, lastName, preferredName, email, role, baseRole
export function useEditUser(payload) {
  const userDispatch = useUserDispatch();
  const [userInfoObj, setUserInfoObj] = useState(payload);
  const accountDispatch = useAccountDispatch();
  const { selectedAccount } = useAuthStore();

  async function editUser() {
    const response = await fetch(`/api/users/${userInfoObj.id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userInfoObj),
    });
    // This api call is only used in one location so changing the response is okay
    if (response.ok) {
      let { ownershipTransferred, previousOwnerData, userData } =
        await response.json();

      if (ownershipTransferred) {
        userDispatch({ type: "edit", payload: previousOwnerData });
        userDispatch({
          type: "userUpdated",
          payload: { id: previousOwnerData?.id },
        });
        accountDispatch({
          type: "editAccount",
          payload: { id: selectedAccount.id, ownerId: userInfoObj.id },
        });
      }
      userDispatch({ type: "edit", payload: userData });
      userDispatch({ type: "userUpdated", payload: { id: userInfoObj.id } });
      return userData;
    }
  }
  return { userInfoObj, setUserInfoObj, editUser };
}

//udpate user info on confirmation page
export function useConfirmUser(payload) {
  const authDispatch = useAuthDispatch();
  const [userInfoObj, setUserInfoObj] = useState(payload);

  async function confirmUser() {
    const response = await fetch(`/api/users/${userInfoObj.id}/confirmation`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userInfoObj),
    });
    if (response.ok) {
      let data = await response.json();
      authDispatch({ type: "updateAuth", payload: data });
      return data;
    }
  }
  return { userInfoObj, setUserInfoObj, confirmUser };
}

//udpate user role from editor to member when editor trial ends
export function useSwitchRoleToMember(id, accountId) {
  const authDispatch = useAuthDispatch();

  async function switchRoleToMember() {
    const response = await fetch(`/api/users/${id}/userrole`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ accountId }),
    });
    if (response.ok) {
      let data = await response.json();
      authDispatch({ type: "updateAuth", payload: data });
      return data;
    }
  }
  return { switchRoleToMember };
}
